export const columns = [
    {
        dataIndex: 'code',
        key: 'code',
        width: 100,
        title: 'Mã',
    },
    {
        dataIndex: 'fieldName',
        key: 'fieldName',
        width: 120,
        title: 'Lĩnh vực',
    },
    {
        dataIndex: 'projectName',
        key: 'projectName',
        width: 120,
        title: 'Dự án',
    },
    {
        dataIndex: 'workTypeName',
        key: 'workTypeName',
        width: 120,
        title: 'Mảng công việc',
    },
    {
        dataIndex: 'purpose',
        key: 'purpose',
        width: 300,
        title: 'Mục tiêu & KR',
    },
    {
        dataIndex: 'picName',
        key: 'picName',
        width: 150,
        title: 'PIC',
    }
]